import { z } from 'zod';

export const InterestSchema = z.object({
  name: z.string(),
});

export type Interest = z.infer<typeof InterestSchema>;
